import { LoginAuth } from "functions/login";
import { jwtDecode } from "jwt-decode";
import { useHistory } from "react-router-dom";
import type {
  AuthFormTypes,
  ResponseAuthTypes,
  TokenPayloadTypes,
} from "types/auth";

export function useAuth() {
  const history = useHistory();

  const authLogin = async (
    parms: AuthFormTypes
  ): Promise<ResponseAuthTypes> => {
    try {
      const resp: ResponseAuthTypes = await LoginAuth(parms);
      const token = resp.access;
      const decoded: TokenPayloadTypes = jwtDecode(token);

      localStorage.setItem("username", parms.username);
      localStorage.setItem("master", String(decoded.master));
      localStorage.setItem("AcessToken", resp.access);
      localStorage.setItem("RefreshToken", resp.refresh);

      history.push("/admin");
      window.location.reload();

      return resp;
    } catch (error: any) {
      throw error.response.data.error;
    }
  };

  return { authLogin };
}
